export const isGbiUser = (email) => email.includes('@groupbyinc.com');
